import { useEffect, useState } from "react";
import { useDashboard } from "../context/DashboardContext";
import { mainCConsensus, useFreqSparkline } from "../hooks/useFreqSparkline";
import { FreqSparkline, METER_C_STYLES, METER_SPARKLINE_SERIES } from "./FreqSparkline";

function formatFreq(hz: number | undefined) {
  if (!Number.isFinite(hz)) return "—";
  return `${hz!.toFixed(3)} Hz`;
}

export function MobileFreqStrip() {
  const data = useDashboard();
  const {
    frames: sparklineFrames,
    lastTs: meterLastTs,
    liveHz: meterLiveHz,
  } = useFreqSparkline(true);

  const cConsensus = mainCConsensus(
    meterLiveHz.main_C,
    meterLiveHz.main_A,
    meterLiveHz.main_B,
    meterLastTs.main_C,
  );
  const cStroke =
    cConsensus === "off"
      ? METER_C_STYLES.off.stroke
      : cConsensus === "stale"
        ? METER_C_STYLES.stale.stroke
        : METER_C_STYLES.agree.stroke;

  const [cShiftView, setCShiftView] = useState(false);

  useEffect(() => {
    if (sparklineFrames.length === 0) setCShiftView(false);
  }, [sparklineFrames.length]);

  return (
    <div className="mobile-freq-strip">
      <div className="mobile-freq-strip__authoritative">
        <span className="mobile-freq-strip__label">Mains frequency</span>
        <span className="mobile-freq-strip__authoritative-value">
          {formatFreq(data.freqLive?.freq_hz)}
        </span>
      </div>

      <div className="mobile-freq-strip__meters">
        {(["main_A", "main_B"] as const).map((id) => (
          <span
            key={id}
            className="mobile-freq-strip__meter"
            style={{ color: METER_SPARKLINE_SERIES[id].stroke }}
          >
            {METER_SPARKLINE_SERIES[id].label} {formatFreq(meterLiveHz[id] ?? undefined)}
          </span>
        ))}
        <span className="mobile-freq-strip__backup" style={{ color: cStroke }}>
          backup: {formatFreq(meterLiveHz.main_C ?? undefined)}
        </span>
        <button
          type="button"
          aria-pressed={cShiftView}
          title="Offset backup trace −5 mHz in chart only"
          onClick={() => setCShiftView((on) => !on)}
          className={[
            "mobile-freq-strip__shift",
            cShiftView ? "mobile-freq-strip__shift--on" : "",
          ].join(" ")}
        >
          {cShiftView ? "shifted" : "shift view"}
        </button>
      </div>

      <div className="mobile-freq-strip__chart">
        <FreqSparkline
          frames={sparklineFrames}
          lastTsC={meterLastTs.main_C}
          shiftView={cShiftView}
        />
      </div>
    </div>
  );
}
